import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import RouteSeo from "./components/feature/RouteSeo";
import RouteSchema from "./components/feature/RouteSchema";
import RouteAnalytics from "./components/feature/RouteAnalytics";
import SmoothAnchors from "./components/feature/SmoothAnchors";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <RouteSeo />
        <RouteSchema />
        <RouteAnalytics />
        <SmoothAnchors />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;